import React, { useState, useEffect, useRef } from 'react';

import './styles.css';

const images = [
  {
    src: require('./images3/СЗФО_94.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_95.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_96.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_97.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_98.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_99.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2000.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2001.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2002.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2003.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2004.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2005.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2006.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2007.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2008.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2009.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2010.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2011.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2012.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2013.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2014.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2015.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2016.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2017.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2018.png'),
    loaded: false,
  },
  {
    src: require('./images3/СЗФО_2019.png'),
    loaded: false,
  },
];

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

/*
class Map extends React.Component {
  componentDidMount() {

    const { ymaps } = window;

    ymaps.ready(function () {
        var myMap = new ymaps.Map('map', {
                center: [68.96761017566147,102.82745279959293],
                zoom: 3
            }, {
                searchControlProvider: 'yandex#search'
            });

        
        ymaps.borders.load('RU', {
            lang: 'ru'
        })
        .then(function (geojson) {
            for (var i = 0; i < geojson.features.length; i++) {
                var geoObject = new ymaps.GeoObject(geojson.features[i]);
                
                geoObject.properties.set({
                  hintContent: Math.random() > 0.5 ? "3G" : "4G",
                });

                geoObject.options.set({
                    fillColor: Math.random() > 0.5 ? "#ffc107" : "#3AB54A",
                    fillOpacity: 0.3,
                });

                myMap.geoObjects.add(geoObject);
            };

            myMap.behaviors.disable('scrollZoom');

            myMap.controls.remove("trafficControl");
            myMap.controls.remove("geolocationControl");
            myMap.controls.remove("routeButtonControl");
            myMap.controls.remove("typeSelector");
            myMap.controls.remove("rulerControl");
            myMap.controls.remove("searchControl"); 
        })
    });
    
  }

  render() {
    // style={{width: "100%", height: "800px"}}
      return (
        <Spreader>
        <div id="map"></div>
      </Spreader>
    );
    }
}

export default Map;

*/

export default props => {
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [loadedIndex, setLoadedIndex] = useState(0);

  useInterval(() => {
    if (!props.isVisible) {
      return;
    }

    let nextVisibleIndex = visibleIndex + 1;
    if (nextVisibleIndex >= images.length) {
      nextVisibleIndex = 0;
    }

    if (images[nextVisibleIndex] && images[nextVisibleIndex].loaded) {
      setVisibleIndex(nextVisibleIndex);
    }
  }, 1000);

  images.forEach(image => {
    let invisibleImage = new Image();

    invisibleImage.onload = function() {
      image.loaded = true;
    };

    invisibleImage.src = image.src;
  });

  return <img style={{ width: '100%' }} src={images[visibleIndex].src} />;
};
